import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Arzum',
  logo: { name: 'Arzum', src: '/logo/arzumcard.png' },
  portrait: { src: '/photo/portrait-arif-emre-unal.png', alt: 'Arif Emre Unal' },
  quote: [
    'The digital maturity measurement process was a smooth experience for us. The Digitopia '
    + 'delivery team took their time to understand Arzum’s inner dynamics before starting '
    + 'the first initiative. They internalized our company’s distinctive business model and '
    + 'managed the process accordingly and we felt this difference from the beginning of the '
    + 'first session to the very last one. Applying a coach-like style, Digitopia empowered '
    + 'us to evaluate ourselves in a very short time by asking the right questions to the '
    + 'right people. Focusing on six different dimensions, they conducted separate studies '
    + 'for each vertical.',
  ],
  attribution: 'Arif Emre Unal, Executive Board Member, CIO & COO',
  story: 'arzum',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 9
